module.exports = __webpack_public_path__ + "img/demo_image_01.535ad648.png";